import { UPDATE_REASON_CODES, REASONS } from 'constants/reasonCodesDB';
import { TYPE_LOGOUT, TYPE_LOGOUT_SOFT } from 'constants/Login';
import { RootState } from 'reducers';
import { ReasonCodes } from 'types/ReasonCodes';

import {
  getCurrentPosLanguage,
  getCurrentPosLanguageOverride,
  posSupportedLangsDict,
} from './configs/settings';

type ReasonCodesState = Record<
  keyof typeof REASONS,
  Record<string, ReasonCodes[]>
>;

export default (
  state = {} as ReasonCodesState,
  { type, payload }: { type: string; payload: ReasonCodesState },
) => {
  switch (type) {
    case TYPE_LOGOUT:
    case TYPE_LOGOUT_SOFT:
      return {} as ReasonCodesState;
    case UPDATE_REASON_CODES:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export const getHasReasonCodes = (purpose: keyof typeof REASONS) => (
  state: RootState,
) => state.reasonCodesDB[purpose] !== undefined;

export const getReasonCodes = (purpose: keyof typeof REASONS) => (
  state: RootState,
) => {
  const activePosLanguage =
    getCurrentPosLanguageOverride(state) || getCurrentPosLanguage(state);
  const lang = posSupportedLangsDict[activePosLanguage] ?? 'eng';
  return state.reasonCodesDB[purpose]?.[lang] || [];
};
